<template>
  <div style="display: flex;" class=" flex-wrap">
    <template v-for="(item, index) in imgs">
      <div v-if="showImg(item)" class="upload-warp" :key="index">
        <img class="hover imgs" :src="item.url">
        <div class="del-mask">
          <div class="icons">
            <Icon type="md-eye" size="18" color="#fff" @click="handlePreview(item.url)" />
            <Icon type="ios-trash" size="18" color="#fff" @click="handleDelImg(index)" />
          </div>
        </div>
        <span v-if="item.jigou" class="og-name">{{item.jigou.name}}</span>
      </div>
    </template>
    <!-- 预览 -->
    <Modal v-model="showPreview" footerHide width="850px" title="图片预览">
      <img :src="previewImg" class="pre-img" />
    </Modal>
  </div>
</template>

<script>
  export default {
    props: {
      /**图片数组 */
      imgs: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        session: this.$store.session,
        showPreview: false,
        previewImg: '',
      }
    },
    methods: {
      /**查看图片权限-自己和下级机构 */
      showImg(item) {
        if (!this.session.jigou || !item.jigou) return false
        return this.session.jigou._id === item.jigou._id || this.session.zhanghao.guanxiajigous.find((jg) => jg._id === item.jigou._id)
      },
      /**预览图片 */
      handlePreview(img) {
        this.showPreview = true
        this.previewImg = img
      },
      /**删除图片 */
      handleDelImg(index) {
        this.$emit('del', index)
      },
    }
  }
</script>

<style scoped lang="less">
  .upload-warp {
    width: 80px;
    height: 80px;
    position: relative;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 2px;
    overflow: hidden;

    .og-name {
      position: absolute;
      bottom: 2px;
      right: 2px;
      color: #333;
      font-size: 10px;
      line-height: 16px;
    }

    .imgs,
    .del-mask {
      width: 100%;
      height: 100%;
      position: absolute;
    }

    .del-mask {
      display: none;
      background: rgba(0, 0, 0, 0.5);

      .icons {
        cursor: pointer;
        position: absolute;
        z-index: 10;
      }
    }

    &:hover {
      .del-mask {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .pre-img {
    width: 100%;
  }

  .watermark {
    position: relative;
    width: 200px;
    height: 200px;
    border: 1px solid;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/ImgUpload/index.vue?0f6b2b1b